<template src='./GestionEstadosOrdenes.html'></template>
<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import formularioOverlay from "../../formularioOverlay/formularioOverlay";
import {
  consultarOrdenes,
  consultarOrdenesEstado,
  descargarOrdenes,
  consultarCicloOrdenes,
  consultarTiempoOrdenes
} from "../../../apiService/request/gestionSeguimientos";
import {
  consultarOrden,
  crearOrdenDesdeFormulario
} from "../../../apiService/request/CrudOrdenes";
import metodos_comunes from "../../../js/metodos_comunes";
import Icono from "../../Icono/Icono";
import { serverBus } from "../../../main";
import {
  consultarTipoEncuentroSeguimiento,
  crearCuestionario,
  consultarEstructuraCuestionarioPorId
} from "../../../apiService/request/CrudSeguimiento";
import mixinGraficas from "../../../js/mixins/mixinGraficas";
import mixinScroll from "../../../js/mixins/mixinScroll";
import FiltrosGestion from "../FiltrosGestion/FiltrosGestion";
import tiemposPaciente from "../TiemposPaciente/tiemposPaciente";
export default {
  data() {
    return {
      // seguimiento: [
      // {
      //   nombre_lista: "Tipo gestión",
      //   key_lista: "tipo_gestion",
      //   opciones_lista:
      //     [
      //       {
      //          nombre: "Gestión llamadas",
      //          key: "llamada",
      //          valor: "Gestión llamadas"
      //        },
      //        {
      //          nombre: "Gestión seguimientos",
      //          key: "seguimiento",
      //          valor: "Gestión seguimientos"
      //        },
      //        {
      //          nombre: "Gestión ayudas diagnósticas",
      //          key: "ayuda_diagnostica",
      //          valor: "Gestión ayudas diagnósticas"
      //        }
      //     ]
      //   }
      // ],
      // fechaActual:"",
      // date: Date.now(),
      // fechaSeleccionada:"",
      // miliSegundos:Number,
      // diaSeleccionado: [],
      // valorSeleccionado: [],
      expanded: [],
      singleExpand: false,
      arrayGraficas: [],
      banderaGrafica: false,
      banderaTabla: false,
      usuarios: [],
      opciones: [
        {
          chart: {
            stacked: true,
            toolbar: {
              show: false
            },
            events: {
              dataPointSelection: (event, chartContext, config) => {
                this.showTable(config.dataPointIndex);
                console.log("dataPointIndex", config);
              },
              click: (event, chartContext, config) => {
                if (
                  event &&
                  event.target &&
                  (event.target.className === "apexcharts-legend-text" ||
                    event.target.className === "apexcharts-legend-series" ||
                    event.target.className === "apexcharts-legend-marker")
                ) {
                  this.showTable(Number(event.target.getAttribute("rel")) - 1);
                }
              }
            }
          },
          legend: {
            // show: true,
            position: "bottom",
            horizontalAlign: "left",
            offsetX: 40,
            height: 90
          },
          states: {
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: "darken",
                value: 0.4
              }
            }
          },
          // colors: ["#3A5FBA", "#3D88C4", "#3F9AAE"],
          colors: [
            "#579FF2",
            "#946EEB",
            "#90A4AE",
            "#F0706C",
            "#B7C53B",
            "#F38D89",
            "#D493B0",
            "#45B8DD",
            "#BA567C",
            "#3ABA8B",
            "#55669F",
            "#EFE18B",
            "#ED8432",
            "#F0AE7B"
          ],
          dataLabels: {
            // enabled: false
            textAnchor: "center",
            style: {
              colors: ["#fff"],
              fontSize: 15
            },
            offsetX: 0
          },
          grid: {
            row: {
              // colors: ["#f9f9f9", "#fff"]
              colors: ["#F4F5F8"]
            }
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: ["#646a6f"],
                fontSize: "14px",
                fontFamily: "Nunito, sans-serif"
              },
              min: 20
            }
          },
          fill: {
            // colors: ["#3D88C4"],
            type: "gradient",
            gradient: {
              shade: "light"
            }
          },
          plotOptions: {
            bar: {
              // horizontal: true
              distributed: true,
              horizontal: true
            },
            colors: ["#3D88C4"]
          },
          yaxis: {
            labels: {
              show: false,
              style: {
                fontSize: 20 /**El texto de la izquierda de la grafica */,
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif"
              }
            }
          }
        }
      ],
      series: [
        {
          data: []
        }
      ],
      item: "",
      loader: null,
      loading3: false,
      page: 1,
      pageCount: 0,
      overlay: false,
      graficaKey: 0,
      itemsPerPage: 5,
      banderaGrafica: false,
      banderaTabla: false,
      headers: [],
      desserts: [],
      sort_by: [],
      sort_desc: [],
      items: [5, 10, 30, 50],
      banderaSubirArchivo: true,
      search: "",
      parametrosHijo: [],
      paciente: {},
      datosConsultaPadre: {},
      verEncuentro:
        "M31.3,8.6h-4V8.1c0-0.6-0.4-1-1-1H25C24.6,5.9,23.4,5,22,5s-2.6,0.9-3,2.1h-1.3c-0.6,0-1,0.4-1,1v0.4h-4c-1.3,0-2.4,1.1-2.4,2.4v23.6c0,1.3,1.1,2.4,2.4,2.4h18.6c1.3,0,2.4-1.1,2.4-2.4V11C33.7,9.7,32.6,8.6,31.3,8.6z M28.9,13.4v18.7H15.1V13.4H28.9z M18.7,9.1h1.1c0.6,0,1-0.4,1-1C20.9,7.5,21.4,7,22,7s1.1,0.5,1.1,1.1c0,0.6,0.4,1,1,1h1.1v2.3h-6.6V9.1zM31.7,34.6c0,0.2-0.2,0.4-0.4,0.4H12.7c-0.2,0-0.4-0.2-0.4-0.4V11c0-0.2,0.2-0.4,0.4-0.4h4v0.9h-2.6c-0.6,0-1,0.4-1,1v20.7c0,0.6,0.4,1,1,1h15.7c0.6,0,1-0.4,1-1V12.4c0-0.6-0.4-1-1-1h-2.6v-0.9h4c0.2,0,0.4,0.2,0.4,0.4V34.6z M17,25.1h2.3v2.3c0,0.6,0.4,1,1,1h3.3c0.6,0,1-0.4,1-1v-2.3H27c0.6,0,1-0.4,1-1v-3.3c0-0.6-0.4-1-1-1h-2.3v-2.3c0-0.6-0.4-1-1-1h-3.3c-0.6,0-1,0.4-1,1v2.3H17c-0.6,0-1,0.4-1,1v3.3C16,24.6,16.4,25.1,17,25.1z M18,21.8h2.3c0.6,0,1-0.4,1-1v-2.3h1.3v2.3c0,0.6,0.4,1,1,1H26v1.3h-2.3c-0.6,0-1,0.4-1,1v2.3h-1.3v-2.3c0-0.6-0.4-1-1-1H18V21.8z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      modificar:
        "M29.8,30.9c-2.2,1.9-4.9,2.9-7.8,2.9c-6.2,0-11.3-4.8-11.8-10.9h1.1c0.3,0,0.6-0.2,0.8-0.4c0.2-0.3,0.2-0.6,0.1-0.9l-2.1-5 C9.9,16.2,9.5,16,9.1,16s-0.8,0.2-0.9,0.6l-2.1,5c-0.1,0.3-0.1,0.7,0.1,0.9C6.4,22.8,6.7,23,7,23h1.2c0.5,7.2,6.5,12.9,13.8,12.9 c3.4,0,6.6-1.2,9.1-3.4c0.4-0.4,0.5-1,0.1-1.4C30.9,30.6,30.2,30.6,29.8,30.9z M9.1,19.5L9.8,21H8.5L9.1,19.5z M22,8.1c-3.4,0-6.6,1.2-9.1,3.4c-0.4,0.4-0.5,1-0.1,1.4c0.4,0.4,1,0.5,1.4,0.1c2.2-1.9,4.9-2.9,7.8-2.9c6.2,0,11.3,4.8,11.8,10.9h-1.1c-0.3,0-0.6,0.2-0.8,0.4c-0.2,0.3-0.2,0.6-0.1,0.9l2.1,5c0.2,0.4,0.5,0.6,0.9,0.6s0.8-0.2,0.9-0.6l2.1-5c0.1-0.3,0.1-0.7-0.1-0.9 C37.6,21.2,37.3,21,37,21h-1.2C35.3,13.8,29.3,8.1,22,8.1z M34.9,24.5L34.2,23h1.3L34.9,24.5z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      agregar:
        "M22,35c-1.7,0-3-1.3-3-3v-7h-7c-1.7,0-3-1.3-3-3s1.3-3,3-3h7v-7c0-1.7,1.3-3,3-3s3,1.3,3,3v7h7c1.7,0,3,1.3,3,3s-1.3,3-3,3 h-7v7C25,33.7,23.7,35,22,35z M12,21c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1,0.4,1,1v8c0,0.6,0.4,1,1,1s1-0.4,1-1v-8c0-0.6,0.4-1,1-1 h8c0.6,0,1-0.4,1-1s-0.4-1-1-1h-8c-0.6,0-1-0.4-1-1v-8c0-0.6-0.4-1-1-1s-1,0.4-1,1v8c0,0.6-0.4,1-1,1H12z M22,44C9.9,44,0,34.1,0,22 S9.9,0,22,0s22,9.9,22,22S34.1,44,22,44z M22,2C11,2,2,11,2,22s9,20,20,20s20-9,20-20S33,2,22,2z",
      usuarios: [],
      iconoBoton:
        "M43,37.3H1c-0.6,0-1,0.4-1,1V43c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1v-4.7C44,37.8,43.6,37.3,43,37.3z M42,42H2v-2.7h40V42zM10.8,23.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v30.3l8.8-8.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L22.7,34.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2L10.8,23.9z"
    };
  },
  mixins: [mixinGraficas, mixinScroll],
  components: {
    apexcharts: VueApexCharts,
    formularioOverlay,
    Icono,
    FiltrosGestion,
    tiemposPaciente
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    }
  },
  methods: {
    async cerrarOverlay(valor) {
      this.paciente = {};
      await this.consultarDatosGrafica(
        this.datosConsultaPadre.tipo_gestion,
        this.datosConsultaPadre.fechaInicial,
        this.datosConsultaPadre.fechaFinal,
        this.datosConsultaPadre.estados
      );
      await this.showTable(
        this.parametrosHijo[0],
        this.parametrosHijo[1],
        this.parametrosHijo[2]
      );
      if (!this.banderaSubirArchivo) {
        this.formularioActualizado();
      }
      const self = this;
      const elementoSeleccionado = self.seguimiento[0].opciones_lista.filter(
        element => element.key == self.datosConsultaPadre.tipo_gestion
      );
      this.opcionSeleccionadaTipoGestion = elementoSeleccionado[0].nombre;
      this.datosConsultaPadre.estados = this.estadosSeleccionados;
      this.overlay = valor;
    },
    cerrarOverlaySinActualizar() {
      this.overlay = false;
    },
    async consultarDatosGrafica(
      tipo_gestion,
      fechaInicial,
      fechaFinal,
      estados
    ) {
      try {
        this.banderaGrafica = false;
        this.banderaTabla = false;
        this.$store.dispatch("setCargando", true);
        // console.log('fechas:',this.milisegundos,fechaActual,(fechaActual-this.milisegundos))
        this.respuestaHijo = await consultarOrdenesEstado(
          tipo_gestion,
          fechaInicial,
          fechaFinal,
          estados
        );
        this.datosConsultaPadre = {
          tipo_gestion,
          fechaInicial,
          fechaFinal,
          estados
        };
        this.respuestaHijo.data.data.headers.push({
          text: "Gestión",
          value: "gestion",
          sortable: false
        });
        this.getGraphicData(this.respuestaHijo, 0);
      } finally {
        this.banderaGrafica = true;
        this.$store.dispatch("setCargando", false);
      }
    },
    async showTable(index) {
      try {
        this.desserts = [];
        this.headers = [];
        this.parametrosHijo = [null, null, index];
        this.tituloHijo = this.respuestaHijo.data.data.ejeX[index];
        this.$store.dispatch("setCargando", true);
        const respuesta = await consultarTiempoOrdenes(
          this.datosConsultaPadre.tipo_gestion,
          this.datosConsultaPadre.fechaInicial,
          this.datosConsultaPadre.fechaFinal,
          this.respuestaHijo.data.data.ejeX[this.parametrosHijo[2]]
        );
        this.$store.dispatch("setCargando", false);
        this.usuarios = respuesta.data.data.usuarios[0];
        this.banderaTabla = true;
        this.desserts = this.usuarios;
        this.headers = respuesta.data.data.headers;
        this.headers.push({
          text: "Gestión",
          value: "gestion",
          sortable: false
        });
        this.sort_by = respuesta.data.data.sort_by;
      } finally {
        setTimeout(() => {
          this.autoScroll("medidaScroll", "graficaGestionEstadoOrdenes", 0);
        }, 100);
      }
    }
  }
};
</script>
<style lang="scss" src='./GestionEstadosOrdenes.scss' scoped>
</style>
<style lang="scss" >
.graficaGestionEstadoOrdenes {
  .v-data-table {
    td:last-child {
      padding: 0;
      min-width: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Gestion/GestionEstadosOrdenes/GestionEstadosOrdenes.vue